import { useTranslation } from "react-i18next";

const Loader: React.FC = () => {
  const { t } = useTranslation();

  return <pre>{t("Loading...")}</pre>;
};

export default Loader;
